import { render, staticRenderFns } from "./CustomElementRender.vue?vue&type=template&id=7b30c709"
import script from "./CustomElementRender.vue?vue&type=script&lang=ts"
export * from "./CustomElementRender.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports